import axios from "axios";
const apiURL = process.env.REACT_APP_API_URL;

export const getBanner = async () => {
  try {
    const res = await axios.get(`${apiURL}/api/banner/current`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};

export const saveBanner = async (payload) => {
  try {
    const res = await axios.post(`${apiURL}/api/banner/save`, payload);
    return res.data;
  } catch (err) {
    console.error(err);
    // Return server error payload when possible so UI can show meaningful message
    if (err.response && err.response.data) {
      return err.response.data;
    }
    return { error: "Network or server error" };
  }
};
